/* =================================================================
   chillpod-buy-section.js
   =================================================================
   PART 1 — Shape selector + scroll position save/restore
   PART 2 — Package selector (בסיסי / פרו)
   PART 3 — Add-ons (ice blocks + mat) — visible only on בסיסי
   ================================================================= */


/* ============================ PART 1 ============================
   Shape selector
   ================================================================ */
(function () {
  const SCROLL_KEY = "hl_shape_scroll";

  function initShapeSelector() {
    const selector = document.getElementById("hlShapeSelector");
    if (!selector) return;

    const current = selector.dataset.current || "chillpod";
    const options = selector.querySelectorAll(".hl-shape-option");
    const nameEl  = document.getElementById("hlShapeSelectedName");

    options.forEach((opt) => {
      const isActive = opt.dataset.product === current;
      opt.classList.toggle("is-active", isActive);
      opt.setAttribute("aria-current", isActive ? "true" : "false");

      if (isActive && nameEl) nameEl.textContent = opt.dataset.name || "";

      const priceEl = opt.querySelector("[data-shape-price]");
      if (priceEl && opt.dataset.price) {
        const cents = Number(opt.dataset.price);
        if (!Number.isNaN(cents) && cents > 0) {
          priceEl.textContent = "₪" + Math.round(cents / 100).toLocaleString("en-US");
        }
      }

      if (opt.dataset.bound === "1") return;
      opt.dataset.bound = "1";

      opt.addEventListener("click", (e) => {
        if (opt.dataset.product === current) { e.preventDefault(); return; }
        e.preventDefault();
        window.location.href = opt.getAttribute("href");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShapeSelector);
  } else {
    initShapeSelector();
  }
})();


/* ============================ PARTS 2 + 3 ==========================
   Package selector + Add-ons
   ================================================================ */
window.hlInitIceAddon = function () {

  // ── Config ────────────────────────────────────────────────────
  const ICE_BUNDLES = [
    { label: "6",  handle: "ib6",  id: "49331587580163", qty: 6,  imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/6_Pack_46d031be-449d-4db8-b860-7afeabbeb4cf.png?v=1778783621" },
    { label: "9",  handle: "ib9",  id: "49331590136067", qty: 9,  imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/9_Pack_c5b86d04-4319-421f-b203-c4357581252e.png?v=1778783621" },
    { label: "12", handle: "ib12", id: "49331591774467", qty: 12, imageUrl: "https://cdn.shopify.com/s/files/1/0609/2141/3891/files/12_Pack_a2da260d-1c7c-4a06-9dca-31dc128631bd.png?v=1778783621" },
  ];

  const ICE_BADGES = {
    "48138351051011": "פופולרי",
    "48064636158211": "הכי משתלם",
  };

  const MAT_IDS = {
    "chillpod":      { variantId: "47840588497155", jsonId: "hl-mat-chillpod-json" },
    "chillpod-plus": { variantId: "47840589480195", jsonId: "hl-mat-chillpod-plus-json" },
  };

  const PRO_BUNDLE_IDS = {
    "chillpod":      { variantId: "48330782376195", jsonId: "hl-pro-bundle-json" },
    "chillpod-plus": { variantId: "48330771693827", jsonId: "hl-pro-bundle-plus-json" },
  };

  // ── DOM refs ──────────────────────────────────────────────────
  const shapeSelectorEl = document.getElementById("hlShapeSelector");
  const currentProduct  = shapeSelectorEl?.dataset?.current || "chillpod";
  const productName     = currentProduct === "chillpod-plus" ? "צ׳ילפוד פלוס" : "צ׳ילפוד";
  const isOutOfStock    = shapeSelectorEl?.dataset?.currentOutOfStock === "true";

  const mainEl = document.getElementById("hl-main-product-json");
  if (!mainEl) return;

  let chillpod;
  try { chillpod = JSON.parse(mainEl.textContent); } catch { return; }

  const chillpodVariant      = chillpod?.variants?.[0];
  const chillpodVariantId    = chillpodVariant ? Number(chillpodVariant.id) : null;
  const chillpodPriceCents   = chillpodVariant ? Number(chillpodVariant.price) : 0;
  const chillpodCompareCents = chillpodVariant?.compare_at_price ? Number(chillpodVariant.compare_at_price) : 0;

  if (!chillpodVariantId) return;

  // ── Sold out: Liquid flag or Shopify availability ─────────────
  const soldOut = isOutOfStock || chillpod?.available === false;

  // ── Parse ice bundle data ─────────────────────────────────────
  const bundleDataMap = new Map();
  for (const bundle of ICE_BUNDLES) {
    const el = document.getElementById(`hl-ice-bundle-product-json-${bundle.handle}`);
    if (!el) continue;
    try {
      const product = JSON.parse(el.textContent);
      const variant = (product?.variants || []).find((v) => String(v.id) === String(bundle.id)) || product?.variants?.[0];
      let imageUrl = null;
      if (variant?.image_id) {
        const img = (product?.images || []).find((i) => i.id === variant.image_id);
        if (img) imageUrl = img.src;
      }
      if (!imageUrl) imageUrl = product?.featured_image || product?.images?.[0]?.src || null;
      if (variant) bundleDataMap.set(String(bundle.id), { price: Number(variant.price) || 0, compare_at_price: Number(variant.compare_at_price || 0), imageUrl });
    } catch { /* ignore */ }
  }
  bundleDataMap.forEach((d) => { if (d.imageUrl) { const i = new Image(); i.src = d.imageUrl; } });

  // ── Parse mat data ────────────────────────────────────────────
  const matConfig = MAT_IDS[currentProduct];
  let matVariantId = null, matPriceCents = 0, matCompareCents = 0, matImageUrl = null;
  if (matConfig) {
    const matEl = document.getElementById(matConfig.jsonId);
    if (matEl) {
      try {
        const matProduct = JSON.parse(matEl.textContent);
        const matVariant = (matProduct?.variants || []).find((v) => String(v.id) === String(matConfig.variantId)) || matProduct?.variants?.[0];
        if (matVariant) {
          matVariantId    = Number(matVariant.id);
          matPriceCents   = Number(matVariant.price) || 0;
          matCompareCents = matVariant.compare_at_price ? Number(matVariant.compare_at_price) : 0;
          matImageUrl     = matProduct?.featured_image || matProduct?.images?.[0]?.src || null;
        }
      } catch { /* ignore */ }
    }
  }

  // ── Parse pro bundle data ─────────────────────────────────────
  const proConfig = PRO_BUNDLE_IDS[currentProduct];
  let proVariantId = null, proPriceCents = 0, proCompareCents = 0;
  if (proConfig) {
    const proEl = document.getElementById(proConfig.jsonId);
    if (proEl) {
      try {
        const proProduct = JSON.parse(proEl.textContent);
        const proVariant = (proProduct?.variants || []).find((v) => String(v.id) === String(proConfig.variantId)) || proProduct?.variants?.[0];
        if (proVariant) {
          proVariantId    = Number(proVariant.id);
          proPriceCents   = Number(proVariant.price) || 0;
          proCompareCents = proVariant.compare_at_price ? Number(proVariant.compare_at_price) : 0;
        }
      } catch { /* ignore */ }
    }
  }

  // ── Element refs ──────────────────────────────────────────────
  const pkgSelector   = document.getElementById("hlPackageSelector");
  const pkgNameEl     = document.getElementById("hlPkgSelectedName");
  const pkgBasicDesc  = document.getElementById("hlPkgBasicDesc");
  const pkgProDesc    = document.getElementById("hlPkgProDesc");
  const pkgBasicPrice = document.getElementById("hlPkgBasicPrice");
  const pkgProPrice   = document.getElementById("hlPkgProPrice");
  const pkgButtons    = pkgSelector ? pkgSelector.querySelectorAll(".hl-pkg-option") : [];

  const addonsRoot    = document.getElementById("hlAddonsRoot");

  const iceCheck       = document.getElementById("hlIceCheck");
  const iceCard        = document.getElementById("hlIceCard");
  const pillsContainer = document.getElementById("hlIcePills");
  const icePriceEl     = document.getElementById("hlIcePrice");
  const iceCompareEl   = document.getElementById("hlIceCompareAt");
  const perUnitEl      = document.getElementById("hlIcePerUnit");
  const iceImgEl       = document.querySelector("#hlIceAddonRoot .hl-ice-image img");
  const badgeEl        = document.getElementById("hlIceBadge");

  const matCheck     = document.getElementById("hlMatCheck");
  const matCard      = document.getElementById("hlMatCard");
  const matPriceEl   = document.getElementById("hlMatPrice");
  const matCompareEl = document.getElementById("hlMatCompareAt");
  const matImgEl     = document.getElementById("hlMatImg");

  const totalEl        = document.getElementById("hlTotalPrice");
  const compareEl      = document.getElementById("hlTotalCompareAt");
  const discountBadgeEl = document.getElementById("hlTotalDiscountBadge");
  const installmentsEl = document.getElementById("hlInstallments");
  const addBtn         = document.getElementById("hlAddBothToCart");

  // ── State ─────────────────────────────────────────────────────
  let selectedPkg   = "pro"; // TEMP — change back to "pro" to restore
  let iceEnabled    = false;
  let matEnabled    = false;
  let selectedIceId = "49331591774467"; // ib12 — was: String(ICE_BUNDLES[0].id)
  
  // ── Helpers ───────────────────────────────────────────────────
  const money  = (cents)   => "₪" + Math.round(cents / 100).toLocaleString("en-US");
  const money2 = (shekels) => "₪" + Number(shekels).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  /* ══ CHILLPOD PLUS OVERRIDES ═══════════════════════════════════
     TO REVERT: set HL_PLUS_OVERRIDES to false. Nothing else to undo.
       1. Pro bundle description text on the Plus page
       2. Hide ice blocks + mat add-ons on the Plus page (basic pkg)
     ══════════════════════════════════════════════════════════════ */
  const HL_PLUS_OVERRIDES = false;

  const isPlus          = currentProduct === "chillpod-plus";
  const PLUS_PRO_DESC   = "צ׳ילפוד פלוס, 12 אייס בלוק ומשטח הגנה";
  const PLUS_NO_ADDONS  = HL_PLUS_OVERRIDES && isPlus;
  /* ══ END CHILLPOD PLUS OVERRIDES ═══════════════════════════════ */

// ── Package descriptions ──────────────────────────────────────
  if (pkgBasicDesc) pkgBasicDesc.textContent = currentProduct === 'chillpod-plus' ? 'גדול במיוחד, מבודד קור, מסגרת מתכת יציבה, מתאים לגובה של עד 2.05 מטר.' : 'גדול ומרווח, מבודד קור, מתאים לגובה של עד 2 מטר.';
  if (pkgProDesc)   pkgProDesc.textContent   = currentProduct === 'chillpod-plus' ? (HL_PLUS_OVERRIDES ? PLUS_PRO_DESC : 'צ׳ילפוד פלוס, משטח הגנה, ו-12 בלוקים להקפאה חוזרת.') : 'צ׳ילפוד ו-12 בלוקים להקפאה חוזרת.';

  // ── Package selector prices ───────────────────────────────────
  if (pkgBasicPrice) pkgBasicPrice.textContent = money(chillpodPriceCents);

  const pkgBasicCompare  = document.getElementById("hlPkgBasicCompare");
  const pkgBasicDiscount = document.getElementById("hlPkgBasicDiscount");
  if (pkgBasicCompare && chillpodCompareCents > chillpodPriceCents) {
    pkgBasicCompare.textContent = money(chillpodCompareCents);
    pkgBasicCompare.style.display = "inline";
    if (pkgBasicDiscount) {
      pkgBasicDiscount.textContent = `${money(chillpodCompareCents - chillpodPriceCents)} הנחה`;
      pkgBasicDiscount.style.display = "inline";
    }
  }

  if (pkgProPrice && proPriceCents) {
    pkgProPrice.textContent = money(proPriceCents);
    const proComparePrice = proCompareCents > proPriceCents ? proCompareCents : 0;
    if (proComparePrice) {
      const pkgProCompare  = document.getElementById("hlPkgProCompare");
      const pkgProDiscount = document.getElementById("hlPkgProDiscount");
      if (pkgProCompare) { pkgProCompare.textContent = money(proComparePrice); pkgProCompare.style.display = "inline"; }
      if (pkgProDiscount) {
        pkgProDiscount.textContent = `${money(proComparePrice - proPriceCents)} הנחה`;
        pkgProDiscount.style.display = "inline";
      }
    }
  }

  // ── Ice pills init ────────────────────────────────────────────
  if (pillsContainer) {
    pillsContainer.innerHTML = ICE_BUNDLES.map((b) => `
      <button
        type="button"
        class="hl-ice-pill${String(b.id) === selectedIceId ? " is-active" : ""}"
        data-id="${b.id}"
        aria-pressed="${String(b.id) === selectedIceId}"
      >${b.label}</button>
    `).join("");

    pillsContainer.addEventListener("click", (e) => {
      e.stopPropagation();
      const pill = e.target.closest(".hl-ice-pill");
      if (!pill) return;
      selectedIceId = pill.dataset.id;
      pillsContainer.querySelectorAll(".hl-ice-pill").forEach((p) => {
        const active = p.dataset.id === selectedIceId;
        p.classList.toggle("is-active", active);
        p.setAttribute("aria-pressed", active ? "true" : "false");
      });
      updateTotals();
      updateIceCard();
    });
  }

  // ── Mat init ──────────────────────────────────────────────────
  if (matPriceEl) matPriceEl.textContent = matPriceCents ? money(matPriceCents) : "—";
  if (matCompareEl && matCompareCents > matPriceCents) {
    matCompareEl.textContent = money(matCompareCents);
    matCompareEl.style.display = "inline";
  }

    // ── Hide mat add-on on ChillPod only ──────────────────────────
  const HL_HIDE_MAT_CHILLPOD = true; // set false to restore
  if (HL_HIDE_MAT_CHILLPOD && currentProduct === "chillpod") {
    if (matCard) matCard.style.display = "none";
    matVariantId  = null;
    matPriceCents = 0;
  }

  // ── Update ice card display ───────────────────────────────────
  function updateIceCard() {
    const bundleMeta = ICE_BUNDLES.find((b) => String(b.id) === selectedIceId);
    const bundleData = bundleDataMap.get(selectedIceId);
    if (!bundleMeta || !bundleData) return;

    if (iceImgEl) iceImgEl.src = bundleMeta.imageUrl || bundleData.imageUrl;

    if (badgeEl) {
      const label = ICE_BADGES[selectedIceId];
      badgeEl.textContent = label || "";
      badgeEl.style.display = label ? "block" : "none";
    }

    const iceCents        = bundleData.price;
    const iceCompareCents = bundleData.compare_at_price;
    const qty             = bundleMeta.qty || 1;

    if (icePriceEl) icePriceEl.textContent = money(iceCents);

    if (iceCompareEl) {
      if (iceCompareCents > iceCents) {
        iceCompareEl.textContent = money(iceCompareCents);
        iceCompareEl.style.display = "inline";
      } else {
        iceCompareEl.style.display = "none";
        iceCompareEl.textContent = "";
      }
    }

    if (perUnitEl) perUnitEl.textContent = `${money2((iceCents / 100) / qty)} ליחידה`;
  }

  // ── Update totals ─────────────────────────────────────────────
  function updateTotals() {
    let total   = 0;
    let compare = 0;

    if (selectedPkg === "pro") {
      total   = proPriceCents;
      compare = proCompareCents;
    } else {
      total   = chillpodPriceCents;
      compare = chillpodCompareCents;

      if (iceEnabled) {
        const bd = bundleDataMap.get(selectedIceId);
        if (bd) {
          total   += bd.price;
          compare += (bd.compare_at_price || bd.price);
        }
      }

      if (matEnabled) {
        total   += matPriceCents;
        compare += (matCompareCents || matPriceCents);
      }
    }

    if (totalEl) totalEl.textContent = money(total);

    if (compareEl) {
      if (compare > total) {
        compareEl.textContent = money(compare);
        compareEl.style.display = "block";
      } else {
        compareEl.style.display = "none";
        compareEl.textContent = "";
      }
    }

    if (discountBadgeEl) {
      if (compare > total) {
        const pct = Math.round((1 - (total / compare)) * 100);
        discountBadgeEl.textContent = `${pct}% הנחה`;
        discountBadgeEl.style.display = "inline-block";
      } else {
        discountBadgeEl.style.display = "none";
        discountBadgeEl.textContent = "";
      }
    }

    if (installmentsEl) {
      const installmentCount = currentProduct === "chillpod-plus" ? 6 : 3;
      const perPayment = (total / 100) / installmentCount;
      installmentsEl.innerHTML = `או <strong>₪${perPayment.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong> ב-${installmentCount} תשלומים ללא ריבית`;
    }

    if (addBtn) {
      addBtn.textContent = soldOut ? "אזל המלאי" : "הוספה לסל";
      addBtn.disabled    = soldOut;
    }
  }

// ── Toggle add-ons visibility ─────────────────────────────────
  let addonsVisible = false;
  let addonsResizeObserver = null;

  function setAddonsVisible(visible) {
    if (!addonsRoot) return;
    addonsVisible = visible;

    if (visible) {
      addonsRoot.style.maxHeight     = addonsRoot.scrollHeight + "px";
      addonsRoot.style.opacity       = "1";
      addonsRoot.style.pointerEvents = "auto";

      // Keep max-height synced to content while open (handles late-loading
      // images) instead of releasing to "none", which raced with fast toggles
      if (!addonsResizeObserver && "ResizeObserver" in window) {
        addonsResizeObserver = new ResizeObserver(() => {
          if (addonsVisible) {
            addonsRoot.style.maxHeight = addonsRoot.scrollHeight + "px";
          }
        });
        addonsResizeObserver.observe(addonsRoot);
      }
    } else {
      // Re-pin to current height first so the close animation still runs
      addonsRoot.style.maxHeight = addonsRoot.scrollHeight + "px";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (addonsVisible) return; // user re-opened before this ran — bail
          addonsRoot.style.maxHeight     = "0px";
          addonsRoot.style.opacity       = "0";
          addonsRoot.style.pointerEvents = "none";
        });
      });
      if (iceEnabled) { iceEnabled = false; syncIceUI(); }
      if (matEnabled) { matEnabled = false; syncMatUI(); }
    }
  }

  // ── Sync checkbox UIs ─────────────────────────────────────────
  function syncIceUI() {
    if (iceCheck) iceCheck.setAttribute("aria-pressed", iceEnabled ? "true" : "false");
    if (iceCard)  iceCard.classList.toggle("is-selected", iceEnabled);
  }

  function syncMatUI() {
    if (matCheck) matCheck.setAttribute("aria-pressed", matEnabled ? "true" : "false");
    if (matCard)  matCard.classList.toggle("is-selected", matEnabled);
  }

  // ── Package selector interaction ──────────────────────────────
  pkgButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      selectedPkg = btn.dataset.pkg;
      pkgButtons.forEach((b) => {
        const active = b.dataset.pkg === selectedPkg;
        b.classList.toggle("is-active", active);
        b.setAttribute("aria-pressed", active ? "true" : "false");
      });
      setAddonsVisible(selectedPkg === "basic" && !PLUS_NO_ADDONS);
      updateTotals();
    });
  });

  // ── Ice card interaction ──────────────────────────────────────
  if (iceCheck) {
    iceCheck.addEventListener("click", (e) => {
      e.stopPropagation();
      iceEnabled = !iceEnabled;
      syncIceUI();
      updateTotals();
    });
  }

  if (iceCard) {
    iceCard.addEventListener("click", (e) => {
      if (e.target.closest(".hl-ice-details-btn, .hl-ice-pill, .hl-ice-pills")) return;
      iceEnabled = !iceEnabled;
      syncIceUI();
      updateTotals();
    });

    iceCard.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        iceEnabled = !iceEnabled;
        syncIceUI();
        updateTotals();
      }
    });
  }

  // ── Mat card interaction ──────────────────────────────────────
  if (matCheck) {
    matCheck.addEventListener("click", (e) => {
      e.stopPropagation();
      matEnabled = !matEnabled;
      syncMatUI();
      updateTotals();
    });
  }

  if (matCard) {
    matCard.addEventListener("click", () => {
      matEnabled = !matEnabled;
      syncMatUI();
      updateTotals();
    });

    matCard.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        matEnabled = !matEnabled;
        syncMatUI();
        updateTotals();
      }
    });
  }

  // ── Add to cart ───────────────────────────────────────────────
  if (addBtn) {
    addBtn.addEventListener("click", async () => {
      if (soldOut) return;
      addBtn.disabled = true;

      let items;
      if (selectedPkg === "pro" && proVariantId) {
        items = [{ id: proVariantId, quantity: 1 }];
      } else {
        items = [{ id: chillpodVariantId, quantity: 1 }];
        if (iceEnabled) items.push({ id: Number(selectedIceId), quantity: 1 });
        if (matEnabled && matVariantId) items.push({ id: matVariantId, quantity: 1 });
      }

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error("cart/add failed");
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
        document.dispatchEvent(new CustomEvent("product:added"));
      } catch (e) {
        console.error(e);
      } finally {
        addBtn.disabled = soldOut;
      }
    });
  }

  // ── Details modal (ice) ───────────────────────────────────────
  const detailsBtn   = document.getElementById("hlIceDetailsBtn");
  const modalOverlay = document.getElementById("hlIceModalOverlay");
  const modalClose   = document.getElementById("hlIceModalClose");

  if (detailsBtn && modalOverlay && modalClose) {
    const openModal = () => {
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top      = `-${scrollY}px`;
      document.body.style.width    = "100%";
      modalOverlay.classList.add("is-open");
      modalOverlay.setAttribute("aria-hidden", "false");
      modalClose.focus();
    };

    const closeModal = () => {
      const scrollY = Math.abs(parseInt(document.body.style.top || "0"));
      document.body.style.position = "";
      document.body.style.top      = "";
      document.body.style.width    = "";
      window.scrollTo(0, scrollY);
      modalOverlay.classList.remove("is-open");
      modalOverlay.setAttribute("aria-hidden", "true");
      detailsBtn.focus();
    };

    detailsBtn.addEventListener("click", (e) => { e.stopPropagation(); openModal(); });
    modalClose.addEventListener("click", closeModal);
    modalOverlay.addEventListener("click", (e) => { if (e.target === modalOverlay) closeModal(); });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modalOverlay.classList.contains("is-open")) closeModal();
    });
  }

  // ── Carousel ──────────────────────────────────────────────────
  const track    = document.getElementById("hlIceCarouselTrack");
  const prevBtn  = document.getElementById("hlIceCarouselPrev");
  const nextBtn  = document.getElementById("hlIceCarouselNext");
  const dotsWrap = document.getElementById("hlIceCarouselDots");

  if (track) {
    const slides = track.querySelectorAll(".hl-ice-carousel-slide");
    const total  = slides.length;
    let   cur    = 0;
    const dots   = dotsWrap ? dotsWrap.querySelectorAll(".hl-ice-carousel-dot") : [];

    const goTo = (index) => {
      cur = Math.max(0, Math.min(index, total - 1));
      track.style.transform = `translateX(${-cur * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle("is-active", i === cur));
      if (prevBtn) prevBtn.classList.toggle("is-hidden", cur === 0);
      if (nextBtn) nextBtn.classList.toggle("is-hidden", cur === total - 1);
    };

    if (prevBtn) prevBtn.addEventListener("click", () => goTo(cur - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => goTo(cur + 1));
    dots.forEach((dot) => dot.addEventListener("click", () => goTo(Number(dot.dataset.index))));

    let touchStartX = 0, touchDeltaX = 0;
    track.addEventListener("touchstart", (e) => { touchStartX = e.touches[0].clientX; touchDeltaX = 0; track.style.transition = "none"; }, { passive: true });
    track.addEventListener("touchmove",  (e) => { touchDeltaX = e.touches[0].clientX - touchStartX; const offset = -(cur * 100) + (touchDeltaX / track.parentElement.offsetWidth) * 100; track.style.transform = `translateX(${offset}%)`; }, { passive: true });
    track.addEventListener("touchend",   () => { track.style.transition = ""; if (touchDeltaX < -40) goTo(cur + 1); else if (touchDeltaX > 40) goTo(cur - 1); else goTo(cur); });

    goTo(0);
  }

  /* ══ SIMPLE MODE ══════════════════════════════════════════════
     Controlled by hl_simple_mode in the Liquid (data-simple-mode).
     Liquid already hides the elements server-side (no flash);
     this just forces the matching state for price + cart.
     ══════════════════════════════════════════════════════════════ */
  const HL_SIMPLE_MODE = shapeSelectorEl?.dataset?.simpleMode === "true";

  if (HL_SIMPLE_MODE) {
    selectedPkg = "basic";
    iceEnabled  = false;

    if (pkgSelector) pkgSelector.style.display = "none";

    const iceRoot = document.getElementById("hlIceAddonRoot");
    if (iceRoot) iceRoot.style.display = "none";

    if (isPlus) {
      setAddonsVisible(true);
    } else if (addonsRoot) {
      addonsRoot.style.display = "none";
    }
  }
  /* ══ END SIMPLE MODE ══════════════════════════════════════════ */

// ── Initial render ────────────────────────────────────────────
  updateIceCard();
  updateTotals();
  syncIceUI();
  syncMatUI();
};

// Auto-run
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () { window.hlInitIceAddon(); });
} else {
  window.hlInitIceAddon();
}
